import styled from '@emotion/styled';

export const Container = styled.span`
  display: flex;
  svg {
    max-height: 20px;
    width: auto;
  }
`;
